<form [formGroup]="form" (submit)="onSubmit()">
  <tn-banner
    type="info"
    [bordered]="true"
    [heading]="'First-time setup' | translate"
    [message]="'No administrator account has been configured yet. Set a password for the TrueNAS administrative user to log in for the first time.' | translate"
  ></tn-banner>

  <tn-form-field [label]="'Username' | translate">
    <tn-input
      formControlName="username"
      name="username"
      autocomplete="username"
      [testId]="'username'"
      [ariaLabel]="'Username' | translate"
      [readonly]="true"
    ></tn-input>
  </tn-form-field>

  <tn-form-field
    [label]="'Password' | translate"
    [errorMessages]="passwordErrorMessages"
  >
    <tn-input
      formControlName="password"
      name="password"
      autocomplete="new-password"
      suffixActionTestId="toggle-password-password"
      [testId]="'password'"
      [required]="true"
      [ariaLabel]="'Password' | translate"
      [inputType]="isPasswordVisible() ? InputType.PlainText : InputType.Password"
      [suffixIcon]="isPasswordVisible() ? tnIconMarker('eye', 'mdi') : tnIconMarker('eye-off', 'mdi')"
      [suffixIconAriaLabel]="isPasswordVisible() ? ('Hide Password' | translate) : ('Show Password' | translate)"
      (onSuffixAction)="isPasswordVisible.set(!isPasswordVisible())"
    ></tn-input>
  </tn-form-field>

  <tn-form-field
    [label]="'Confirm Password' | translate"
    [errorMessages]="password2ErrorMessages"
  >
    <tn-input
      formControlName="password2"
      name="password2"
      autocomplete="new-password"
      suffixActionTestId="toggle-password-password-2"
      [testId]="'password-2'"
      [required]="true"
      [ariaLabel]="'Confirm Password' | translate"
      [inputType]="isPassword2Visible() ? InputType.PlainText : InputType.Password"
      [suffixIcon]="isPassword2Visible() ? tnIconMarker('eye', 'mdi') : tnIconMarker('eye-off', 'mdi')"
      [suffixIconAriaLabel]="isPassword2Visible() ? ('Hide Password' | translate) : ('Show Password' | translate)"
      (onSuffixAction)="isPassword2Visible.set(!isPassword2Visible())"
    ></tn-input>
  </tn-form-field>

  <tn-button
    color="primary"
    type="submit"
    class="submit-button"
    [testId]="'sign-in'"
    [label]="isSubmitting() ? ('Logging in...' | translate) : ('Sign In' | translate)"
    [disabled]="!form.valid || isLoading()"
  ></tn-button>
</form>
